import {Injectable} from '@angular/core';
import {ConfigurationService} from '~/app/core/services/configuration.service';
import {catchError, map} from 'rxjs/operators';
import {ErrorService} from "~/app/core/services/error.service";
import {UserAdmin} from '~/app/core/reports/models/user-admin';
import {UserService} from "~/app/core/services/user.service";
import {HomeOffice} from "@model/HomeOffice";
import {LocalStorageIndexedService} from "~/app/web/AppProvider/LocalStorageIndexedService";
import {AppEnums} from "~/app/web/AppProvider/AppEnums";
import {Report} from "~/app/core/reports/models/report";
import {UserAdminReport} from "~/app/core/reports/models/user-admin-report";
import {UserAdminStore} from "~/app/core/reports/models/user-admin-store";
import {BaseService} from "~/app/core/services/base.service";
import { lastValueFrom } from 'rxjs';

const GET_USERS = '/admin/users/'; //{username} GET
const GET_REPORTS = '/report/all/'; //{hoId}/{username} GET
const UPDATE_REPORTS = '/admin/userreports/' //{hoId}/{username}/{adminUsername} PUT
const GET_REPORT_CATEGORIES = '/report/categories' //GET
const GET_USER_STORES = '/admin/userstores/' // {hoId}/{adminUsername} GET
const UPDATE_STORES = '/admin/userstores/' // {hoId}/{username}/{adminUsername} PUT

@Injectable({
  providedIn: 'root'
})

export class UserAccessService {
  userAdminList: UserAdmin[];
  userIdList: string[];
  private _selectedHomeOffice: HomeOffice;


  constructor(private baseService: BaseService,
              private configuration: ConfigurationService,
              private errorService: ErrorService,
              private userService: UserService,
              private _localStorage: LocalStorageIndexedService) {
  }

  setUserData(userAdminList: UserAdmin[]) {
    this.userAdminList = userAdminList;
  }

  getUserData() {
    return this.userAdminList;
  }

  setUserIds(userIds: string[]) {
    this.userIdList = userIds;
  }

  getUserIds(): string[] {
    return this.userIdList;
  }

  getSelectedHoId(): string {
    this._selectedHomeOffice = this._localStorage.getFromSession(AppEnums.HOME_OFFICE);
    if (this._selectedHomeOffice) {
      return this._selectedHomeOffice.hoId;
    }
    return '';
  }

  async getUsers(username: string): Promise<UserAdmin[]> {
    this.userAdminList = await lastValueFrom(this.baseService.getHttpObject<UserAdmin[]>(
      'getUsers',
      'user-access-service',
      this.configuration.RESTURL + GET_USERS + username));
    return this.userAdminList;
  }

  async getAllReportCategories(): Promise<Report[]> {
    return lastValueFrom(this.baseService.getHttpObject<Report[]>(
      'getAllReportCategories',
      'user-access-service',
      this.configuration.RESTURL + GET_REPORT_CATEGORIES));
  }

  async getAssignedReports(hoId: string, userName: string): Promise<UserAdminReport[]> {
    const results = await lastValueFrom(this.baseService.getHttpObject<UserAdminReport[]>(
      'getAssignedReports',
      'user-access-service',
      this.configuration.RESTURL + GET_REPORTS + hoId + '/' + userName))
      .catch(this.errorService.handleError('user-access.service getReports', []))
    return results as UserAdminReport[];
  }

  updateReports(hoId: number, selectedUsername: string, username: string, updateList: any[]): Promise<any> {
    return lastValueFrom(this.baseService.putHttpObject<any>(
      'updateReports',
      'user-access-service',
      this.configuration.RESTURL + UPDATE_REPORTS + hoId + '/' + selectedUsername + '/' + username, JSON.stringify(updateList)))
      .catch(catchError(this.errorService.handleError('user-access.service  updateReports', []))
      );
  }

  async getUserStores(hoId: string, userName: string): Promise<UserAdminStore[]> {
    const results = await lastValueFrom(this.baseService.getHttpObject<UserAdminStore[]>(
      'getUserStores',
      'user-access-service',
      this.configuration.RESTURL + GET_USER_STORES + hoId + '/' + userName))
      .catch(this.errorService.handleError('user-access.service getUserStores', []))
    return results as UserAdminStore[];
  }

  updateStores(hoId: number, selectedUsername: string, username: string, updateList: any[]): Promise<any> {
    return lastValueFrom(this.baseService.putHttpObject<any>(
      'updateStores',
      'user-access-service',
      this.configuration.RESTURL + UPDATE_STORES + hoId + '/' + selectedUsername + '/' + username, JSON.stringify(updateList)))
      .catch(catchError(this.errorService.handleError('user-access.service  updateStores', []))
      );
  }

}
